module.exports = __webpack_public_path__ + "img/lotto-6-45.b819158a.png";